import { render, staticRenderFns } from "./PatientItem.vue?vue&type=template&id=4d8751c5"
import script from "./PatientItem.vue?vue&type=script&lang=js"
export * from "./PatientItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports